<template>
	<el-dialog append-to-body :close-on-click-modal="false" @close="bCloseHandle" :visible.sync="visible" custom-class="timeDil" width="880px">
		<div slot="title" style="font-size: 16px">
			选择预约时间 <span style="margin-left: 20px; color: #999; font-size: 14px"><i class="el-icon-warning-outline"></i> 最小预约时间是一小时。</span>
		</div>
		<div class="timeBox">
			<table class="timeTable" cellspacing="0" v-loading="dataListLoading">
				<thead class="timeHeader">
					<tr>
						<th class="th_head">
							<div class="box">
								<em class="day">日期</em>
								<em class="time">时间</em>
								<div class="box-line"></div>
							</div>
						</th>
						<th v-for="(item, index) of dayArr" :key="index">
							<div class="weekDay">
								<em class="week">{{ item.week }}</em>
								<em class="day_num">{{ item.day }}</em>
							</div>
						</th>
					</tr>
				</thead>
				<tbody class="timeBody">
					<tr v-for="(row, i) of tBodyArr" :key="i">
						<td>{{ timeArr[i] }}</td>
						<td
							v-for="(col, j) of row"
							:key="j"
							:class="col.sty"
							@click="timeCellClick(i, j, col.sty, col.type)"
							:style="{
								cursor: col.sty.includes('have') ? 'not-allowed' : 'pointer',
							}"
						>
							{{ col.val }}
						</td>
					</tr>
				</tbody>
			</table>
			<div class="btnbox">
				<el-button round size="small" @click="visible = false">取消</el-button>
				<el-button type="primary" size="small" round @click="submitHandle()">确定</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			dataListLoading: false,
			orderId: null,
			prn: '',
			orderType: '',
			pageTitle: '',
			pageUrl: '',
			timeArr: ['09:00~10:00', '10:00~11:00', '11:00~12:00', '13:00~14:00', '14:00~15:00', '15:00~16:00', '16:00~17:00'],
			matrix: [],
			dayArr: [],
			tBodyArr: [],
			offset: [],
		}
	},
	created() {},
	methods: {
		init(prn, orderType, orderId) {
			this.dataListLoading = true
			this.prn = prn
			this.orderType = orderType
			this.orderId = orderId || null
			this.visible = true
			this.buildTheader()
			this.getPanelInfo()
		},
		// 面板信息
		getPanelInfo() {
			this.$http
				.post(this.$api.orderApi.searchAppt, { goodsPrn: this.prn })
				.then(({ data }) => {
					let panle = data.data
					var matrix = [
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
						[null, null, null, null, null, null, null],
					]
					for (var k = 0; k < panle.length; k++) {
						for (var m = 0; m < panle[k].length; m++) {
							matrix[m][k] = panle[k][m]
						}
					}
					this.matrix = matrix
					for (var i = 0; i < matrix.length; i++) {
						var tdArr = []
						for (var j = 0; j < matrix[i].length; j++) {
							var val = ''
							var sty = []
							var strSt = ''
							if (j == 0) {
								var frameArr = this.timeArr[i].split('~')
								var time1 = this.dayArr[0]['day'] + ' ' + frameArr[1]
								if (new Date().getTime() >= new Date(time1).getTime()) {
									// 过期
									// val = '不可预约'
									val = matrix[i][j].label
									sty = ['have']
									strSt = 'ygq'
								} else {
									// val = matrix[i][j] ? '已预约' : '可预约'
									// sty = matrix[i][j] ? ['have'] : ['chooseEl']
									val = matrix[i][j].label
									sty = matrix[i][j].st ? ['have'] : ['chooseEl']
									strSt = ''
								}
							} else {
								// val = matrix[i][j] ? '已预约' : '可预约'
								// sty = matrix[i][j] ? ['have'] : ['chooseEl']
								val = matrix[i][j].label
								sty = matrix[i][j].st ? ['have'] : ['chooseEl']
								strSt = ''
							}
							let type = matrix[i][j].type
							tdArr.push({ val, sty, strSt, type, point: j + '' + i })
						}
						this.tBodyArr.push(tdArr)
					}
					this.dataListLoading = false
					console.log(this.tBodyArr)
				})
				.then(() => {
					if (this.orderId) {
						// this.$http.get(this.$api.orderApi.getOrderAppt, {}).then(({ data }) => {
						//   console.log(data);
						// });
						console.log(222222)
					}
				})
				.catch(() => {
					this.dataListLoading = false
				})
		},

		// 构建表头
		buildTheader() {
			var dayArr = []
			var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
			var localStr = ['今天', '明天', '后天']
			for (var t = 0; t < 7; t++) {
				dayArr.push({
					week: t < 3 ? localStr[t] : weeks[Date.today().addDays(t).getDay()],
					day: Date.today().addDays(t).toString('yyyy-MM-dd'),
				})
			}
			this.dayArr = dayArr
		},
		timeCellClick(i, j, st) {
			// console.log(type,'tyopppppppp')
			if (st.includes('have')) {
				return
			}
			this.offset.push(j + '' + i)
			this.fn(i, j, 'offset', 'isHavaTrue', 'leisure', '中间已有预约或被占用或逢节假日周末，请重新选择！')
		},
		fn(i, j, listName, methodsName, typeName, msg) {
			if (this[listName].length > 2) {
				this[listName] = [this[listName][this[listName].length - 1]]
			}
			if (this[listName].length == 2) {
				var max = String(Math.max.apply(null, this[listName]))
				var min = String(Math.min.apply(null, this[listName]))
				max.length < 2 ? (max = '0' + max) : max
				min.length < 2 ? (min = '0' + min) : min
				this[listName] = [min, max]
				// 判断范围内是否存在已预约
				var result = this[methodsName](this[listName], this.tBodyArr, typeName)
				if (result) {
					this.$message({
						message: msg,
						type: 'warning',
					})
					return
				}
				for (var x = 0; x < this.tBodyArr.length; x++) {
					for (var y = 0; y < this.tBodyArr[x].length; y++) {
						let index = parseInt(y + '' + x)
						if (index >= parseInt(min) && index <= parseInt(max)) {
							this.tBodyArr[x][y]['sty'].push('active')
						}
					}
				}
			} else {
				this.tBodyArr[i][j]['sty'].push('active')
				for (var k = 0; k < this.tBodyArr.length; k++) {
					for (var m = 0; m < this.tBodyArr[k].length; m++) {
						if (this.tBodyArr[k][m]['sty'].includes('active')) {
							this.tBodyArr[k][m]['sty'] = this.tBodyArr[k][m]['sty'].map(item => {
								if (item != 'active') {
									return item
								}
							})
						}
					}
				}
				this.tBodyArr[i][j]['sty'].push('active')
			}
		},
		// 判断范围内是否存在已经预约的时间段
		isHavaTrue(arr, data, typeName) {
			var result = false
			var start = parseInt(arr[0])
			var end = parseInt(arr[1])
			for (var i = 0; i < data.length; i++) {
				for (var j = 0; j < data[i].length; j++) {
					var currPoint = parseInt(data[i][j]['point'])
					// var val = data[i][j]["val"];
					let type = data[i][j]['type']
					if (currPoint >= start && currPoint <= end && type != typeName) {
						result = true
						this.typeNameSt = type
					}
				}
			}
			return result
		},
		bCloseHandle() {
			this.matrix = []
			this.dayArr = []
			this.tBodyArr = []
			this.offset = []
		},
		// 提交
		submitHandle() {
			if (this.offset.length <= 0) {
				this.$message({
					message: '请选择预约时间！',
					type: 'warning',
				})
				return
			}
			var startTime = ''
			var endTime = ''

			let arr = []
			this.tBodyArr.forEach(a => {
				a.forEach(b => {
					if (b.sty.includes('active')) {
						arr.push(b.point)
					}
				})
			})

			arr = arr.sort()

			if (arr.length == 1) {
				// var d = this.dayArr[parseInt(this.offset[0].toString().charAt(0))]["day"];
				// var tArr = this.timeArr[parseInt(this.offset[0].toString().charAt(1))].split("~");
				// startTime = d + " " + tArr[0];
				// endTime = d + " " + tArr[1];
				// console.log(startTime);
				// console.log(endTime);

				var d = this.dayArr[parseInt(arr[0].toString().charAt(0))]['day']
				var tArr = this.timeArr[parseInt(arr[0].toString().charAt(1))].split('~')
				startTime = d + ' ' + tArr[0]
				endTime = d + ' ' + tArr[1]
			}

			if (arr.length >= 2) {
				var ds = this.dayArr[parseInt(arr[0].toString().charAt(0))]['day']
				var de = this.dayArr[parseInt(arr[arr.length - 1].toString().charAt(0))]['day']
				var tArr1 = this.timeArr[parseInt(arr[0].toString().charAt(1))].split('~')
				var tArr2 = this.timeArr[parseInt(arr[arr.length - 1].toString().charAt(1))].split('~')
				startTime = ds + ' ' + tArr1[0]
				endTime = de + ' ' + tArr2[1]
			}

			// if (this.offset.length == 2) {
			//   var ds = this.dayArr[parseInt(this.offset[0].toString().charAt(0))]["day"];
			//   var de = this.dayArr[parseInt(this.offset[1].toString().charAt(0))]["day"];
			//   var tArr1 = this.timeArr[parseInt(this.offset[0].toString().charAt(1))].split("~");
			//   var tArr2 = this.timeArr[parseInt(this.offset[1].toString().charAt(1))].split("~");
			//   startTime = ds + " " + tArr1[0];
			//   endTime = de + " " + tArr2[1];
			//   console.log(startTime,'startTime');
			//   console.log(endTime,'endTime');
			// }

			let params = {
				goodsPrn: this.prn,
				orderType: this.orderType,
				startTime: startTime,
				endTime: endTime,
			}
			console.log(params, 'paramsparams')
			if (!this.orderId) {
				this.$emit('createOrder', params)
				this.visible = false
			} else {
				this.$emit('updateTime', params)
				this.visible = false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep table:not([cellpadding]) th,
table:not([cellpadding]) td {
	padding: 0rem;
}
.timeTable {
	width: 800px;
	margin: 0 auto;
	border-collapse: collapse;
	border-spacing: 0;
	table-layout: fixed;
	min-height: 410px;
}
.timeTable tr td {
	padding: 11px;
	border: 1px solid #ccc;
	text-align: center;
	cursor: pointer;
	user-select: none;
}
.timeTable tr td.active {
	background: #2962b0;
	color: #fff;
}
.timeTable tr th {
	border: 1px solid #ccc;
	text-align: center;
	background: #f4f7fb;
	font-weight: normal;
	width: 99px;
}
.timeTable .th_head {
	width: 120px;
	position: relative;
}
.box {
	border-top: 65px #f4f7fb solid; /*上边框宽度等于表格第一行行高*/
	border-left: 119px #fff solid; /*左边框宽度等于表格第一行第一格宽度*/
}
.box-line {
	width: 135px;
	height: 1px;
	background: #ccc;
	transform: rotate(28.5deg);
	position: absolute;
	left: -8px;
	top: 32px;

}
.weekDay .day_num,
.weekDay .week {
	display: block;
	font-style: normal;
}
.day,
.time {
	font-style: normal;
	display: block;
	position: absolute;
	width: 120px;
	height: 30px;
	line-height: 30px;
}
.day {
	top: 8px;
	left: 23px;
}
.time {
	top: 32px;
	left: -21px;
}

.timeBody .chooseEl {
	color: #2962b0;
}
.timeBody .have {
	color: #c1c1c1;
}
.btnbox {
	text-align: center;
}
</style>
